<template>
  <div class="fixed inset-0 w-full h-full overflow-hidden" :class="backgroundClass">
    <!-- Nodos animados -->
    <div 
      v-for="(node, index) in nodes" 
      :key="index"
      class="floating-node"
      :style="getNodeStyle(node, index)"
    ></div>
    
    <!-- Slot para contenido -->
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  colors?: string[]
  nodeCount?: number
  animationSpeed?: number
}

const props = withDefaults(defineProps<Props>(), {
  colors: () => ['from-blue-100', 'via-blue-200', 'to-blue-300'],
  nodeCount: 6,
  animationSpeed: 6
})

const backgroundClass = computed(() => {
  return `bg-gradient-to-br ${props.colors.join(' ')}`
})

const nodes = computed(() => {
  const positions = [
    { top: '10%', left: '15%', size: 120 },
    { top: '20%', right: '20%', size: 80 },
    { bottom: '25%', left: '10%', size: 150 },
    { bottom: '15%', right: '25%', size: 100 },
    { top: '50%', left: '5%', size: 90 },
    { top: '60%', right: '10%', size: 70 },
    { top: '30%', left: '50%', size: 110 },
    { bottom: '40%', right: '15%', size: 85 },
    { top: '70%', left: '25%', size: 95 },
    { bottom: '60%', left: '60%', size: 75 },
    { top: '15%', right: '45%', size: 65 },
    { bottom: '10%', left: '40%', size: 105 },
    { top: '45%', right: '5%', size: 88 },
    { bottom: '50%', left: '80%', size: 92 },
    { top: '80%', right: '40%', size: 78 },
    { top: '5%', left: '70%', size: 115 },
    { bottom: '80%', right: '60%', size: 82 }
  ]
  
  return positions.slice(0, props.nodeCount)
})

const getNodeStyle = (node: any, index: number) => {
  const delay = index * 0.5
  const duration = props.animationSpeed + (index % 3)
  
  return {
    width: `${node.size}px`,
    height: `${node.size}px`,
    top: node.top,
    left: node.left,
    right: node.right,
    bottom: node.bottom,
    animationDelay: `${delay}s`,
    animationDuration: `${duration}s`
  }
}
</script>

<style scoped>
.floating-node {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(45deg, rgba(59, 130, 246, 0.4), rgba(147, 197, 253, 0.6));
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) translateX(0px) scale(1);
    opacity: 0.7;
  }
  25% {
    transform: translateY(-20px) translateX(10px) scale(1.1);
    opacity: 0.9;
  }
  50% {
    transform: translateY(-10px) translateX(-15px) scale(0.9);
    opacity: 0.6;
  }
  75% {
    transform: translateY(-30px) translateX(5px) scale(1.05);
    opacity: 0.8;
  }
}
</style>